/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import autoTemplateComponent from './core/auto-template-component'
import toggleMenu from './core/menu'
import searchTest from '../../components/search/search-autocomplete'
import { createRoot } from 'react-dom/client'
import toggleCookiebotPreferences from './libraries/cookiebot'

import App from '../../components/archives/algolia-index'
import AlgoliaSearchResults from '../../components/search/results/search-results'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()
  toggleMenu()
  searchTest()
  toggleCookiebotPreferences()

  // Archive Grids
  const archivesTarget = document.getElementById('js-archive-root')
  if (archivesTarget !== null) {
    const root = createRoot(archivesTarget)
    root.render(<App />)
  }

  // Search Results
  const searchTarget = document.getElementById('js-search-root')
  if (searchTarget !== null) {
    const root = createRoot(searchTarget)
    root.render(<AlgoliaSearchResults />)
  }

  // Canvas Animation
  if (document.getElementById('js--canvas-logo')) {
    import('./libraries/rive')
      .then((module) => {
        const Rive = module.default
        Rive()
      })
      .catch((error) => console.error('Failed to load animation:', error))
  }

  // Anchors
  if (document.getElementById('js--anchored')) {
    import('../../components/anchor/anchor')
      .then((module) => {
        const Anchor = module.default
        Anchor()
      })
      .catch((error) => console.error('Failed to load anchor:', error))
  }

  // Lightbox
  if (document.querySelector('.js-lightbox')) {
    import('./core/lightbox')
      .then((module) => {
        const Gallery = module.default
        Gallery()
      })
      .catch((error) => console.error('Failed to load lightbox:', error))
  }
})
